import './widget.less';
import b_ from 'b_';
import React from 'react';
import { debounce } from 'lodash';
import { WidgetProps } from 'controls/designer/features/widgets/widgetProps';
import { DefaultWidgetWrapper } from 'controls/designer/features/widgets/defaultWidgetWrapper';
import { GlobalTimePeriodConfig } from 'controls/designer/features/widgets/globalTimeSelector/types';
import { AllowedPeriods, GlobalTimeSelectorStore } from 'controls/designer/features/widgets/globalTimeSelector/store';
import { Section } from 'controls/react/layout/section';
import { i18n } from './localization';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { TimePeriodAppearance, TimePeriodSelector } from 'controls/react/form/timePeriodSelector';
import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { observer } from 'mobx-react';
import { fromStringsArray } from 'controls/react/ant/ant-select/utils/fromStringsArray';

const b = b_.with('global-time-period-selector-widget');

const GlobalTimeSelectorWidget = class InnerWidget extends React.Component<WidgetProps<GlobalTimePeriodConfig>> {
	store: GlobalTimeSelectorStore;

	constructor(props: WidgetProps<GlobalTimePeriodConfig>) {
		super(props);
		this.store = new GlobalTimeSelectorStore({ config: props.config, designer: props.designer });
	}

	componentDidMount() {
		this.store.updateTimeSettings();
	}

	render() {
		return (
			<DefaultWidgetWrapper {...this.props} containerClass={b()} showHeader={false}>
				<Section appearance={'none'} contentPadding={true} childrenPadding={true} direction={'row'} onClick={this.redirect}>
					{this.store.model.periodEnabled && (
						<FormEntryNew label={'Time period'} model={this.store.model} modelField={'period'}>
							<TimePeriodSelector size={'small'} periods={AllowedPeriods} appearance={TimePeriodAppearance.Buttons} />
						</FormEntryNew>
					)}
					{this.store.model.timeZoneEnabled && (
						<FormEntryNew label={i18n('Time zone')} model={this.store.model} modelField={'timezone'}>
							<AntSelect options={fromStringsArray(this.store.timezones.data)} loading={this.store.timezones.loading} />
						</FormEntryNew>
					)}
				</Section>
			</DefaultWidgetWrapper>
		);
	}

	// If click on button it triggers 2 events, and if in settings popup, it opens 2 popups
	redirect = debounce(
		() => {
			this.props.navigator.go({});
		},
		300,
		{ leading: true, trailing: false },
	);

	componentWillUnmount() {
		this.store.destroy();
	}
};

export default observer(GlobalTimeSelectorWidget);
